import { CommonModule } from "@angular/common";
import { AfterViewInit, ChangeDetectionStrategy, Component, Signal, ViewChild, WritableSignal, computed, effect, signal } from '@angular/core';
import { PageComponent } from "src/app/layout/pages/page/page.component";
import { MyButtonComponent } from "../../../shared/components/buttons/my-button/my-button.component";
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { IApiKey } from "../models/api-key.model";
import { AmministrazioneService } from "../aministrazione.service";
import {MatFormFieldModule} from '@angular/material/form-field';
import { DialogService } from "src/app/core/services/dialog.service";
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatButtonModule} from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import {MatGridListModule} from '@angular/material/grid-list';
import { UTENTI_COLUMNS } from "../utenti.config";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { IUtente } from "../models/utenti.model";
import { UtentiService } from "../utenti.service";
import { PageListComponent } from "src/app/layout/pages/page-list/page-list.component";
import { toSignal } from "@angular/core/rxjs-interop";
import { Router } from "@angular/router";
import { InputTextComponent } from "../../../shared/components/inputs/input-text/input-text.component";
import { InputPasswordComponent } from "../../../shared/components/inputs/input-password/input-password.component";
@Component({
    selector: 'app-amministrazione-user-page',
    standalone: true,
    templateUrl: './amministrazione-user-page.component.html',
    styleUrls: ['./amministrazione-user-page.component.css'],
    imports: [
    CommonModule,
    PageComponent,
    MyButtonComponent,
    MatMenuModule,
    MatIconModule,
    PageListComponent,
    ClipboardModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatGridListModule,
    InputTextComponent,
    InputPasswordComponent
],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmministrazioneUserPageComponent {
    columns = UTENTI_COLUMNS;
    insertForm: FormGroup;
    customClickFunction:Function=(row:any)=>{
      
        this.navigateToDetail(row.id.toString())
      
    }
  
    constructor(
      private readonly fb: FormBuilder,
      public readonly service: UtentiService,
      private router: Router,
      private dialogService:DialogService
    ) {
      this.insertForm = this.fb.group({
        username: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required]),
        password: new FormControl('', [Validators.required]),
        passwordMatch: new FormControl('', [Validators.required]),
      });
    }

    private navigateToDetail(id:string) {
      const currentUrl = this.router.url;
      const urlSegments = currentUrl.split('/');
      urlSegments.push(id.toString());
      const newUrl = urlSegments.join('/');
      this.router.navigate([newUrl]);
    }

    onEditFunction(servizio?:any){
      if(servizio){
        this.insertForm.get("username")?.setValue(this.insertForm.get("username")?.value.toLowerCase())
        servizio?.createUser(this.insertForm.value).subscribe((val:any)=>{
          this.dialogService.success('Dati salvati correttamente', false);
        })
        this.insertForm.reset()
      }
  
    }
}
